module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/twitter-2bf12f9518c7a39a8847ccdb1297054a.svg&quot;;"